/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import { Trans } from "react-i18next";
import i18n from "i18next";
import {
  getEmployees,
  getPositions,
  getExportCompanies,
  companyTransfer,
  hideModal,
} from "actions";
import toastr from "toastr";
import Select from "react-select";

class CompanyTransfer extends Component {
  state = {
    companies: [],
    selectedCompany: null,
    positions: [],
    selectedPosition: null,
  };

  componentDidMount() {
    this.getCompanies();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedCompany !== this.state.selectedCompany) {
      this.getPositions();
      this.setState({ selectedPosition: null });
    }
  }

  getCompanies() {
    this.props.getExportCompanies(
      this.onBegin,
      (res) => {
        this.props.onProcessEnd();
        this.setState({
          companies: res.data.data.companies.map((company) => {
            return { value: company.id, label: company.name };
          }),
        });
      },
      this.onError
    );
  }

  getPositions() {
    this.props.getPositions(
      this.state.selectedCompany,
      this.onBegin,
      (res) => {
        this.props.onProcessEnd();
        this.setState({
          positions: res.data.data.positions.map((position) => {
            return { value: position.id, label: position.name };
          }),
        });
      },
      this.onError
    );
  }

  getEmployees = () => {
    this.props.getEmployees(this.onBegin, this.onSuccess, this.onError);
  };

  companyTransfer() {
    if (this.state.selectedCompany === null) {
      toastr.error(i18n.t("employeemanagement_company-cannot-be-empty"));
      return false;
    }

    if (this.state.selectedPosition === null) {
      toastr.error(i18n.t("employeemanagement_position-cannot-be-empty"));
      return false;
    }

    let formData = {
      employeeId: this.props.employee.id,
      positionId: this.state.selectedPosition,
      dealerId: this.state.selectedCompany,
    };

    this.props.companyTransfer(
      this.props.employee.id,
      formData,
      this.onBegin,
      this.onCompanyTransferSuccess,
      this.onError
    );
  }

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    console.log(err);
    toastr.error(err.response.data.message);
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
  };

  onCompanyTransferSuccess = (res) => {
    toastr.success(i18n.t("10570"));
    this.getEmployees();
    this.props.onProcessEnd();
    this.props.hideModal();
  };

  renderFormHeader() {
    return null;
  }

  renderFormBody() {
    return (
      <div>
        <span className="d-inline-block mb-4">
          <b>{this.props.employee.fullname}</b> -{" "}
          {this.props.employee.position?.name}
        </span>

        <form>
          <div className="form-row">
            <div className="form-group col-md-12">
              <label htmlFor="name">
                <Trans desc="Lütfen bir bayi seçiniz">
                  employeemanagement_select-a-company
                </Trans>
              </label>
              <Select
                options={this.state.companies}
                onChange={(e) => this.setState({ selectedCompany: e.value })}
                placeholder={i18n.t("10521")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            <div className="form-group col-md-12">
              <label htmlFor="name">
                <Trans desc="Lütfen bir pozisyon seçiniz">
                  employeemanagement_select-a-position
                </Trans>
              </label>
              <Select
                options={this.state.positions}
                value={
                  this.state.selectedPosition
                    ? this.state.positions.find(
                        (z) => z.value === this.state?.selectedPosition
                      )
                    : null
                }
                onChange={(e) => this.setState({ selectedPosition: e.value })}
                placeholder={i18n.t("10521")}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderFormFooter() {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn-action btn-blue"
          onClick={() => this.companyTransfer()}
        >
          <Trans desc="Gönder">10567</Trans>
        </button>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.props.spinner}
        {this.renderFormHeader()}
        {this.renderFormBody()}
        {this.renderFormFooter()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getEmployees,
  companyTransfer,
  getPositions,
  getExportCompanies,
  hideModal,
})(containsLongRunningProcess(requireAuth(CompanyTransfer)));
